import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpGeneralService } from '../../shared';
import { CONFIG } from '../../shared/config';
let usersPrivilegesUrl = CONFIG.baseUrls.UsersPrivilege;

export interface Place {

    id: number,
    secLoginId: number,
    vplacesId: number,
    selected: true;
    levelNo:number;
    ResourceCode:number;
   
}

@Injectable()
export class PlaceService {
    constructor(private httpGeneralService: HttpGeneralService)
    { }
    getPlaces(type: number, secloginId: number) {
        return this.httpGeneralService.getWith(usersPrivilegesUrl + "/" + type + "/" + secloginId);
    }
    addPlace(user: Place[]) {
        return this.httpGeneralService.add(user , usersPrivilegesUrl );
    }
}
